// extracted by mini-css-extract-plugin
module.exports = {"root":"NOHEfficiencyLineChart_root__1UmYu","yUnitLabel":"NOHEfficiencyLineChart_yUnitLabel__tkBuU"};